import {
  getCountryListFetch,
  getmediaSourceFetch,
  getSummaryListFetch,
  getPredictDataFetch,
} from "../../api/api";
// import Axios from "axios"
const state = {
  mediaList: [],
  countryList: [],
  summaryList: [],
  totalEstimateTimes: 0,
  totalRoi: 0,
  popuRoi: 0,
  increRoi: 0,
  country: null,
  PredictDataList: [],
  PredictDimension: 1,
  totalIncomeDiffer: 0,
  totalPopuDiffer: 0,
  totalArpuDiffer: 0,
};

const actions = {
  async getCountryListAndMedia({ commit }, { afid, cb }) {
    try {
      const data1 = await getCountryListFetch({ afid });
      const data2 = await getmediaSourceFetch();
      Promise.all([data1, data2]).then((result) => {
        commit("setcountryAndMedia", result);
        cb(result[0]);
      });
    } catch (e) {
      throw new Error(e);
    }
  },
  async getSummaryList({ commit }, { param, cb }) {
    try {
      const data = await getSummaryListFetch({ data: JSON.stringify(param) });
      console.log(data);
      cb(data);
      data.collecs.map((v) => {
        v.estimateTimes = Number(v.estimateTimes);
        v.estimateValue = Number(v.estimateValue);
        v.increRoi = v.increRoi ? Number(v.increRoi.toFixed(2)) : 0;
        v.popuRoi = v.popuRoi ? Number(v.popuRoi.toFixed(2)) : 0;
      });
      commit("setSummaryList", data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async getPredictData({ commit }, { param, cb }) {
    try {
      const data = await getPredictDataFetch({ data: JSON.stringify(param) });
      // Axios.get("/api/getpredictData", {
      //   params: param
      // }).then((data) => {
      //   console.log(data);
      //   cb(data)
      //   commit('setPredictDimension', param.dimension)
      //   commit('setPredictDataList', data.data)
      // });
      cb(data);
      commit("setPredictDimension", param.dimension);
      commit("setPredictDataList", data);
      // data.collecs.map(v => {
      //   v.estimateTimes = Number(v.estimateTimes);
      //   v.estimateValue = Number(v.estimateValue);
      //   v.increRoi = v.increRoi ? Number(v.increRoi.toFixed(2)) : 0;
      //   v.popuRoi = v.popuRoi ? Number(v.popuRoi.toFixed(2)) : 0
      // })
    } catch (e) {
      throw new Error(e);
    }
  },
};

const mutations = {
  setcountryAndMedia(state, data) {
    state.countryList = data[0].countryList;
    state.mediaList = data[1].mediaList;
  },
  setSummaryList(state, data) {
    state.summaryList = data.collecs;
    state.totalEstimateTimes = data.totalEstimateTimes;
    state.totalRoi = data.totalRoi;
    state.increRoi = data.increRoi;
    state.popuRoi = data.popuRoi;
    state.totalIncomeDiffer = data.totalIncomeDiffer;
    state.totalPopuDiffer = data.totalPopuDiffer;
    state.totalArpuDiffer = data.totalArpuDiffer;
  },
  setCountry(state, data) {
    state.country = data.country;
  },
  setPredictDataList(state, data) {
    state.PredictDataList = data.predictionDatas;
  },
  setPredictDimension(state, data) {
    state.PredictDimension = data;
  },
};

export default {
  state,
  actions,
  mutations,
};
